import { getDebugLogger } from '@ori/checkout-utils';
import { lazy, Suspense } from 'react';
import type { FC } from 'react';

import { APP_NAME } from '../../constants';
import { useBasketSharing } from '../../hooks';
import { Loader } from '../Loader';
import { ShareButton } from '../ShareButton';
import { SharingPopup } from './styles';
import type { SharingWrapperProps } from './types';

const logDebug = getDebugLogger(APP_NAME);

const CopyLinkPanel = lazy(async () => import('./CopyLinkPanel'));
const SharingPanel = lazy(async () => import('./SharingPanel'));

export const SharingWrapper: FC<SharingWrapperProps> = (props) => {
  const { copyLinkProps, isCopyLinkOpen, isPanelOpen, isPopupOpen, panelProps, popupProps, shareButtonProps } =
    useBasketSharing(props);

  logDebug('Rendering SharingWrapper.tsx, popupProps:', popupProps);

  return (
    <>
      <ShareButton {...shareButtonProps} />
      {isPopupOpen ? (
        <SharingPopup {...popupProps}>
          {isPanelOpen ? (
            <Suspense fallback={<Loader />}>
              <SharingPanel {...panelProps} />
            </Suspense>
          ) : null}
          {isCopyLinkOpen ? (
            <Suspense fallback={<Loader />}>
              <CopyLinkPanel {...copyLinkProps} />
            </Suspense>
          ) : null}
        </SharingPopup>
      ) : null}
    </>
  );
};
